import { Field } from "formik";
import React from "react";
import { withNamespace } from "components/Form/FormikControls";
import { useFieldState } from "hooks";
import {
  FieldType,
  FieldValueType,
} from "containers/Settings/RuleBooks/constants";
import { parseCheckValue } from "containers/Settings/RuleBooks/lib";

export interface ConstantDataSourceField<T = unknown> {
  value: T;
  valueType: ValueInObj<typeof FieldValueType> | null;
  source: "CONSTANT";
}

interface ConstantDataSourceProps {
  fieldType: ValueInObj<typeof FieldType>;
  namespace: string;
  dataTour?: string;
}

export function ConstantDataSource(props: ConstantDataSourceProps) {
  const { fieldType, namespace: ns, dataTour } = props;

  const name = withNamespace(ns, "value");
  const [value, setValue] = useFieldState(ns);

  function onChangeValue({ target }) {
    const valueType =
      fieldType === FieldType.NUMERIC ? FieldValueType.DECIMAL : null;

    const updatedField = {
      ...value,
      value: parseCheckValue(fieldType, target.value),
      valueType,
    };

    setValue(updatedField);
  }

  return (
    <Field
      data-tour={`${dataTour}Value`}
      className="p-2"
      name={name}
      onChange={onChangeValue}
      placeholder="(constant)"
      required
    />
  );
}
